
import { useSpring, animated } from 'react-spring'

export const Subscribe = ()=>{
    const styles = useSpring({
        from: { background: "#f08484" },
        to: [
          { background: "#F53838" },
          { background: "#f08484"},
        ],
        config: { duration: "1500" },
        loop:true
    })
    return(
        <section className="flex container subscribe" >
            <div className="subscribe-text" >
                <h2>Subscribe Now for Get <br/>Special Features!</h2>
                <p>Let's subscribe with us and find the fun.</p>
            </div>
            <animated.div style={styles} className="main-button subscribe-button">Get Started</animated.div>
        </section>
    )
}